import { render, staticRenderFns } from "./SnowFlake.vue?vue&type=template&id=40482e23&"
import script from "./SnowFlake.vue?vue&type=script&lang=ts&"
export * from "./SnowFlake.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports